
import { axiosInstance, baseUrl, handleErrors } from "./auth";
export const DELETE_FILE = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/common/deleteFile`, params);
        return response.data
    }
    catch (error) {
        handleErrors(error)
    }
}
export const PAYMENT_SUCCESS = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/plan/payment`, params);
        return response.data
    }
    catch (error) {
        handleErrors(error)
    }
}
